import React, { useContext, useEffect, useRef, useState } from "react";
import { AppBar, Toolbar, IconButton, Typography, Drawer, List, ListItem, ListItemText, Collapse, Button, Box, Container, Modal, Paper } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { useTheme } from "@mui/material/styles";
import SegmentRoundedIcon from "@mui/icons-material/SegmentRounded";
import "./Header.css";
import { Link, NavLink, useNavigate } from "react-router-dom";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import SettingsIcon from '@mui/icons-material/Settings';
import { useLocation } from "react-router-dom";
import CloseIcon from '@mui/icons-material/Close';
import ListItemIcon from '@mui/material/ListItemIcon';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import Darkmode from "../../DarkMode/Darkmode";
import ListItemButton from '@mui/material/ListItemButton';
import lightLogo from '../../../Images/fouchain-logo-light.svg';
import darkLogo from "../../../Images/fouchain-logo-dark.svg";
import { ThemeContext } from "../../DarkMode/ThemeProvider";
import DynamicHelmet from "../../DynamicHelmet/DynamicHelmet";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import LoginIcon from '@mui/icons-material/Login';
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch, useSelector } from "react-redux";
import { getUserDetail } from "../../../Actions/UserDetailAction";
import { userLogout } from "../../../Actions/AuthAction";
import { persistor } from "../../../store";
// notificaiton
import socket from "../../../utils/Socket";
import SecurityIcon from '@mui/icons-material/Security';
import AvatarImg from '../../../Images/avatar.jpg'
import FactCheckRoundedIcon from '@mui/icons-material/FactCheckRounded';
import DownloadRoundedIcon from '@mui/icons-material/DownloadRounded';
import UploadRoundedIcon from '@mui/icons-material/UploadRounded';
import { handleImageError, maskEmail } from "../../../Helper/helper";
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';

// Profile
const profiles = [
    { icon: <ManageAccountsIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'My profile', href: '/my-profile' },
    { icon: <DownloadRoundedIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Deposit', href: '/deposit' },
    { icon: <UploadRoundedIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Withdraw', href: '/withdraw' },
    { icon: <FactCheckRoundedIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'KYC', href: '/Kyc' },
    // { icon: <AccountBalanceIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Bank Detail', href: '/bank-details' },
    { icon: <SecurityIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Security Settings', href: '/two-fa-profile' },
    { icon: <SupportAgentIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Support', href: '/support' },
    { icon: <SettingsIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Change Password', href: '/change-password' },
    { icon: <LoginIcon sx={{ color: 'var(--color-PrimaryText)' }} />, label: 'Log Out', href: '/login' },
];

// Header menu configuration
const headerMenuItems = [
    {
        label: 'Markets',
        link: '/market',
        isAuth: false,
    },
    {
        label: 'Trade',
        link: '/trade',
        isAuth: false,
    },
    {
        label: 'History',
        link: '/transaction-history',
        isAuth: true,
    },
    {
        label: 'Portfolio',
        link: '/portfolio',
        isAuth: true,
    },
    {
        label: 'Investment',
        link: '/investment',
        isAuth: true,
    },
];

const ModalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '300px', md: '450px' },
    bgcolor: 'var(--color-BasicBg)',
    borderRadius: "10px",
    boxShadow: 24,
    p: 3,
};

const HeaderNew = () => {

    // Hooks
    const theme = useTheme();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const timeoutRef = useRef(null);
    const { isLightMode } = useContext(ThemeContext);

    // Selectors
    const { settings } = useSelector((state) => state.site);
    const { isAuthenticated } = useSelector((state) => state.auth);
    const { notifications } = useSelector((state) => state.notification);
    const { stpData, stpStatus } = useSelector((state) => state.tradeSTP);
    const { userDetailData, userDetailStatus } = useSelector((state) => state.user);

    // States
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenu, setActiveMenu] = useState(null);
    const [mobileOpen, setMobileOpen] = useState(false);

    const handleMobileToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const [expandedMenu, setExpandedMenu] = useState(null);

    const [expandedNotifId, setExpandedNotifId] = useState(null);
    const [isLogoutModalOpen, setIsLogoutModalOpen] = useState(false);

    const handleLogoutModalOpen = () => setIsLogoutModalOpen(true);
    const handleLogoutModalClose = () => setIsLogoutModalOpen(false);

    const toggleExpand = (notifId) => {
        setExpandedNotifId(expandedNotifId === notifId ? null : notifId);
    };
    const [isHovered, setIsHovered] = useState(false);
    const handleMouseEnter = () => {
        clearTimeout(timeoutRef.current); // cancel close if re-enter
        setIsHovered(true);
    };
    const handleMouseLeave = () => {
        // timeoutRef.current = setTimeout(() => {
        setIsHovered(false);
        // }, 300); // delay in ms
    };

    const [maskedEmail, setMaskedEmail] = useState("")
    const [selectedSymbol, setSelectedSymbol] = useState('BTCUSDT');
    const [notificationList, setNotificationList] = useState([]);

    useEffect(() => {
        if (!isAuthenticated) return;
        dispatch(getUserDetail())
    }, [isAuthenticated])

    useEffect(() => {
        if (!isAuthenticated) return;
        setInterval(() => {
            dispatch(getUserDetail())
        }, 30000);
    }, [isAuthenticated])


    useEffect(() => {
        if (userDetailStatus === true) {
            setMaskedEmail(maskEmail(userDetailData?.email))
        }

        if (location?.pathname) {
            const queryParams = new URLSearchParams(location.search);
            queryParams.delete("symbol");
        }
    }, [location])

    useEffect(() => {
        if (location.pathname !== "/trade") return;
        if (!stpStatus || !stpData?.result?.length) return;

        const queryParams = new URLSearchParams(location.search);
        const urlSymbol = queryParams.get("symbol");

        // URL always wins
        if (urlSymbol) {
            setSelectedSymbol(urlSymbol);
            return;
        }

        // Prefer BTCUSDT if available
        const symbols = stpData.result.map(item => item.symbol);
        const defaultSymbol = symbols.includes("BTCUSDT") ? "BTCUSDT" : symbols[0];

        setSelectedSymbol(defaultSymbol);

        queryParams.set("symbol", defaultSymbol);
        navigate(`${location.pathname}?${queryParams.toString()}`, { replace: true });

    }, [location.pathname, location.search, stpStatus, stpData]);

    useEffect(() => {
        socket.on("updatenotification", (data) => {
            setNotificationList((prevData) =>
                prevData.map((item) => {
                    if (item.uid === data.uid) {
                        return {
                            ...item,
                            title: data.title,
                            description: data?.description,
                            deleteStatus: data?.deleteStatus,
                            createdAt: data?.createdAt,
                            status: data?.status,
                        };
                    }
                    return item;
                })
            );
        });
        return () => {
            socket.off("updatenotification");
        };
    }, [notifications]);

    useEffect(() => {
        if (notifications && notifications.length > 0) {
            setNotificationList((prevList) => {
                const merged = [...prevList, ...notifications];
                const uniqueMap = new Map();
                merged.forEach((n) => uniqueMap.set(n._id, n)); // Assuming _id is unique
                return Array.from(uniqueMap.values());
            });
        }
    }, [notifications]);

    const handleLogout = () => {
        dispatch(userLogout());
        dispatch({ type: "RESET_APP" });
        persistor.purge();
        localStorage.clear();
        handleLogoutModalClose();
        navigate("/login");
    }

    return (
        <div className="header-main">
            <DynamicHelmet />
            <AppBar position="fixed" sx={{ boxShadow: 'none', background: 'var(--color-BasicBg)' }} >
                <Container maxWidth="xl">
                    <Toolbar
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "0px !important",
                            background: 'none',

                        }}
                    >
                        <div className="display-1">
                            <Link to={'/'}>
                                <div className="logo">
                                    <img width={120} src={!isLightMode ? lightLogo : darkLogo} alt="logo" />
                                </div>
                            </Link>
                        </div>
                        <div>
                            {/* Desktop Menu */}
                            <div className="header-leftside">
                                {headerMenuItems
                                    .filter((menu) => {
                                        if (menu.isAuth) {
                                            return isAuthenticated
                                        }
                                        return true
                                    })
                                    .map((menu, i) => (
                                        <div
                                            key={i}
                                            className={`header-menu-item ${menu.dropdown ? "header-dropdown-menu" : ""}`}
                                        >
                                            {menu.dropdown ? (
                                                <>
                                                    <span className="header-menu-item_view typography-Subtitle4">
                                                        <NavLink
                                                            to={menu.link}
                                                            className={({ isActive }) =>
                                                                `header-menu-link ${isActive ? "active" : ""}`
                                                            }
                                                        >
                                                            {menu.label}
                                                        </NavLink>

                                                        <svg
                                                            className="bn-svg header-menu-item_dropdown-icon"
                                                            viewBox="0 0 24 24"
                                                        >
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M12.11 12.178L16 8.287l1.768 1.768-5.657 5.657-1.768-1.768-3.889-3.889 1.768-1.768 3.889 3.89z"
                                                                fill="currentColor"
                                                            />
                                                        </svg>
                                                    </span>

                                                    <div className="header-menu-subgrid header-menu-subgrid-2">
                                                        {menu.dropdown.map((group, gIdx) => (
                                                            <div className="header-menu-subgrid-group" key={gIdx}>
                                                                {group.items.map((item, idx) => (
                                                                    <div className="header-menu-subgrid-group-li" key={idx}>
                                                                        <NavLink
                                                                            to={
                                                                                item.link === "/trade"
                                                                                    ? `/trade?symbol=${selectedSymbol}`
                                                                                    : item.link
                                                                            }
                                                                            className={({ isActive }) =>
                                                                                `header-nav-subitem ${isActive ? "active" : ""}`
                                                                            }
                                                                        >
                                                                            <div className="header-nav-subicon_warp">
                                                                                {item.icon}
                                                                            </div>

                                                                            <div className="header-nav-subitemtext">
                                                                                <div className="header-nav-subtitle">
                                                                                    <div className="typography-Subtitle4">
                                                                                        {item.title}
                                                                                    </div>

                                                                                    <svg
                                                                                        className="bn-svg header-nav-subarrow"
                                                                                        viewBox="0 0 24 24"
                                                                                    >
                                                                                        <path
                                                                                            fillRule="evenodd"
                                                                                            clipRule="evenodd"
                                                                                            d="M21 11.999l-7.071-7.071-1.768 1.768 4.055 4.054H2.999v2.5h13.216l-4.054 4.053 1.768 1.768L21 12v-.001z"
                                                                                            fill="currentColor"
                                                                                        />
                                                                                    </svg>
                                                                                </div>

                                                                                <p className="header-nav-subdesc typography-caption1">
                                                                                    {item.description}
                                                                                </p>
                                                                            </div>
                                                                        </NavLink>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        ))}
                                                    </div>
                                                </>
                                            ) : (
                                                <NavLink
                                                    to={menu.link}
                                                    className={({ isActive }) =>
                                                        `header-menu-link ${isActive ? "active" : ""}`
                                                    }
                                                >
                                                    {menu.label}
                                                </NavLink>
                                            )}
                                        </div>
                                    ))}
                            </div>
                        </div>

                        <Box className="header-menu-buttons" sx={{ display: "flex", alignItems: "center", gap: "15px", }} >
                            {isAuthenticated ?
                                <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} className="sample-one" sx={{ position: 'relative', display: 'flex' }} >

                                    <img
                                        src={userDetailData?.profileImg ? userDetailData?.profileImg : AvatarImg}
                                        onClick={() => navigate('/my-profile')}
                                        className={isHovered ? 'active' : ''}
                                        alt="profiles" width={50}
                                        onError={(e) => handleImageError(e, AvatarImg)}
                                        style={{
                                            color: 'var(--color-PrimaryText)',
                                            cursor: 'pointer',
                                            transition: 'color 0.2s',
                                            fontSize: '28px',
                                            objectFit: 'cover',
                                            borderRadius: 30
                                        }}
                                    />
                                    {isHovered && (
                                        <Box
                                            sx={{
                                                position: 'absolute',
                                                top: '100%',
                                                right: 0,
                                                mt: 1,
                                                bgcolor: 'var(--color-CardBg)',
                                                boxShadow: 'var(--shadow-shadow2)',
                                                borderRadius: 3,
                                                zIndex: 10,
                                                minWidth: 250,
                                                '& .MuiAvatar-root': {
                                                    width: 32,
                                                    height: 32,
                                                    ml: -0.5,
                                                    mr: 1,
                                                },
                                                '&::before': {
                                                    content: '""',
                                                    display: 'block',
                                                    position: 'absolute',
                                                    top: 0,
                                                    right: 10,
                                                    width: 30,
                                                    height: 30,
                                                    bgcolor: 'transparent',
                                                    transform: 'translateY(-50%) rotate(45deg)',
                                                    zIndex: 0,
                                                },
                                            }}
                                        >
                                            <div className="display-1" style={{ padding: '20px 20px 10px 20px' }}>
                                                <img src={userDetailData?.profileImg ? userDetailData?.profileImg : AvatarImg}
                                                    alt="profiles" width={50}
                                                    onError={(e) => handleImageError(e, AvatarImg)}
                                                    style={{ objectFit: 'cover', borderRadius: 30 }}
                                                />
                                                <div className="">
                                                    <h4 className="gold-color">{maskedEmail}</h4>
                                                    {/* <span style={{ fontSize: '12px', background: 'var(--color-Input)', padding: '5px 10px', borderRadius: '8px' }}>Regular User</span> */}
                                                </div>
                                            </div>
                                            <List component="nav">
                                                {profiles.map((item, index) => (
                                                    <React.Fragment key={index}>
                                                        {/* Add divider before Log Out */}
                                                        {item.label === 'Log Out' && <div style={{ border: '0.5px solid var(--color-Line)' }} />}

                                                        <ListItemButton
                                                            // component={NavLink}
                                                            // to={item.href}
                                                            component={item.label === 'Log Out' ? 'button' : NavLink}
                                                            to={item.label === 'Log Out' ? undefined : item.href}
                                                            onClick={() => {
                                                                if (item.label === 'Log Out') {
                                                                    handleLogoutModalOpen();
                                                                }
                                                            }}
                                                            sx={{
                                                                '&:hover': { backgroundColor: 'var(--color-bg3)' },
                                                                minHeight: 48,
                                                                width: '100%'
                                                            }}
                                                        >
                                                            <ListItemIcon sx={{ minWidth: '40px' }}>
                                                                {item.icon}
                                                            </ListItemIcon>
                                                            <ListItemText primary={item.label} />
                                                        </ListItemButton>
                                                    </React.Fragment>
                                                ))}
                                            </List>
                                        </Box>
                                    )}
                                </Box>
                                :
                                <>
                                    <NavLink to="/login" className='gold-color' style={{ textDecoration: "none", fontSize: 18, color: "#111827", fontWeight: 600, }}>
                                        Login
                                    </NavLink>
                                    <div className="golden-btn">
                                        <Button onClick={() => navigate("/register")} >Sign Up</Button>
                                    </div>
                                </>
                            }

                            {/* Mobile Menu Button */}
                            <IconButton
                                className="mobile-menu-bnutton"
                                edge="end"
                                color="inherit"
                                onClick={handleMobileToggle}
                            // sx={{ display: { md: "none" }, fill: '#000' }}
                            >
                                <SegmentRoundedIcon sx={{ color: 'var(--color-TextLink)' }} />
                            </IconButton>
                        </Box>
                    </Toolbar>
                </Container>

                {/* Mobile Drawer Menu */}
                <Drawer
                    anchor="right"
                    open={mobileOpen}
                    onClose={handleMobileToggle}
                    sx={{
                        mt: 1,
                        "& .MuiPaper-root": {
                            background: "var(--color-CardBg)",
                            color: "#000",
                            width: { xs: "280px", md: "350px" },
                            // padding: '10px 20px'
                            borderRadius: '15px 0px'
                        },
                    }}
                >
                    <div className="display-1" style={{ justifyContent: 'space-between', padding: '0px 0px 0px 10px' }}>
                        <Link>
                            <div className="logo">
                                <img src={!isLightMode ? lightLogo : darkLogo} alt="logo" width={120} />
                            </div>
                        </Link>
                        <div className="text-end" style={{ padding: '5px 20px', color: 'var(--color-TextLink)' }}><CloseIcon onClick={handleMobileToggle} /></div>
                    </div>
                    <List>
                        {headerMenuItems?.map((menu) => (
                            <div key={menu.label}>
                                {!menu?.dropdown?.length ? (
                                    <ListItem sx={{ padding: '8px 15px' }} button onClick={() => navigate(menu.link)}>
                                        <ListItemText sx={{ color: 'var(--color-PrimaryText)' }} primary={menu.label} />
                                    </ListItem>
                                ) : (
                                    <ListItem sx={{ padding: '8px 15px' }} button onClick={() => toggleExpand(menu.label)}>
                                        <ListItemText sx={{ color: 'var(--color-PrimaryText)' }} primary={menu.label} />
                                        {expandedMenu === menu.label ? <ExpandLessIcon sx={{ color: 'var(--color-PrimaryText)' }} /> : <ExpandMoreIcon sx={{ color: 'var(--color-PrimaryText)' }} />}
                                    </ListItem>
                                )}

                                {/* Dropdown for items if they exist */}
                                <Collapse in={expandedMenu === menu.label} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {(menu?.dropdown || []).map((section, idx) => (
                                            <div key={idx}>
                                                {section.title && (
                                                    <Typography
                                                        variant="subtitle2"
                                                        sx={{ pl: 4, mt: 1, fontWeight: "bold", color: 'var(--color-PrimaryText)' }}
                                                    >
                                                        {section.title}
                                                    </Typography>
                                                )}
                                                {(section.items || []).map((item, subIdx) => (
                                                    <Link
                                                        to={item.link}
                                                        key={subIdx}
                                                        style={{ textDecoration: "none", color: "inherit", color: 'var(--color-PrimaryText)' }}
                                                    >
                                                        <ListItem button sx={{ pl: 6 }}>
                                                            <ListItemText sx={{ color: 'var(--color-PrimaryText)' }} primary={item.title} />
                                                        </ListItem>
                                                    </Link>
                                                ))}
                                            </div>
                                        ))}
                                    </List>
                                </Collapse>
                            </div>
                        ))}

                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: "center",
                                justifyContent: 'center',
                                gap: "15px",
                            }}
                            className="mt-40"
                        >
                            {
                                isAuthenticated ?
                                    <Button
                                        variant="outlined"
                                        sx={{
                                            background: 'var(--color-BtnBg)',
                                            color: "#fff",
                                            textTransform: "none",
                                            borderRadius: "8px",
                                            transition: "all 0.3s ease-in-out",
                                            "&:hover": {
                                                transform: "scale(1.05)",
                                            },
                                        }}
                                        onClick={() => {
                                            dispatch(userLogout());
                                            persistor.purge();
                                            localStorage.clear();
                                            navigate("/login");
                                        }}
                                    >
                                        LogOut
                                    </Button>
                                    :

                                    <Button
                                        variant="outlined"
                                        sx={{
                                            background: 'var(--color-BtnBg)',
                                            color: "#fff",
                                            textTransform: "none",
                                            borderRadius: "8px",
                                            transition: "all 0.3s ease-in-out",
                                            "&:hover": {
                                                transform: "scale(1.05)",
                                            },
                                        }}
                                        onClick={() => navigate("/register")}
                                    >
                                        Sign up
                                    </Button>
                            }

                            <div className="">
                                <Darkmode />
                            </div>

                        </Box>
                    </List>

                </Drawer>

                {/* Logout Popup */}
                <Modal open={isLogoutModalOpen} onClose={handleLogoutModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" >
                    <Box sx={ModalStyle} className="res-modal">
                        <div className="display-2">
                            <h2 className="gold-color" style={{ fontWeight: 900 }}>Logout</h2>
                            <CancelRoundedIcon onClick={handleLogoutModalClose} sx={{ color: "var(--color-TextLink)", fontSize: "30px", cursor: "pointer" }} />
                        </div>

                        <div className="input-common mt-10">
                            <Paper elevation={0} sx={{ textAlign: "center", p: 1, background: "transparent" }} >
                                <Box sx={{ width: 90, height: 90, mx: "auto", mb: 2, borderRadius: "50%", background: "#F3F4F6", display: "flex", alignItems: "center", justifyContent: "center", }} >
                                    <LogoutIcon sx={{ fontSize: 50, color: "#FF9800" }} />
                                </Box>
                                <Typography variant="h5" fontWeight={700} gutterBottom >Logout</Typography>
                                <Typography variant="body1" sx={{ mb: 3, lineHeight: 1.7 }}>Are you sure you want to logout?</Typography>
                            </Paper>
                        </div>

                        <div className="display-2 mt-20" >
                            <div className="blu-btn text-center ">
                                <Button fullWidth onClick={handleLogoutModalClose}>Cancel</Button>
                            </div>
                            <div className="blu-btn text-center">
                                <Button fullWidth onClick={handleLogout}>Logout</Button>
                            </div>
                        </div>
                    </Box>
                </Modal>

            </AppBar>
        </div>
    );
};

export default HeaderNew;
